import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { SchoolApi } from '../../../api/client';
import Initials from '../../../components/ui/Initials';
import { FaChalkboardTeacher } from '../../../components/ui/icons';

interface Props {
  sectionId: number;
  currentTeacherId: number | null;
}

export default function HomeroomTeacherDropdown({ sectionId, currentTeacherId }: Props) {
  const qc = useQueryClient();
  const teachersQ = useQuery({
    queryKey: ['school', 'teachers_in_institution'],
    queryFn: () => SchoolApi.teachersInInstitution(),
  });
  const setMut = useMutation({
    mutationFn: (teacher_profile_id: number | null) =>
      SchoolApi.setSectionHomeroom({ section_id: sectionId, teacher_profile_id }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['school', 'section', sectionId] });
      qc.invalidateQueries({ queryKey: ['school', 'sections'] });
    },
  });
  const teachers = teachersQ.data?.teachers ?? [];
  const current = teachers.find((t) => t.profile_id === currentTeacherId);

  return (
    <div>
      <label className="mb-1.5 block font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-muted" htmlFor="homeroom-sel">Homeroom teacher</label>
      <div className="flex min-h-[44px] w-full items-center gap-2.5 rounded-[12px] border border-line-strong bg-surface px-3.5">
        {current
          ? <Initials name={`${current.first_name} ${current.last_name}`} className="!h-7 !w-7 !rounded-[9px] !text-[11px]" />
          : <span aria-hidden="true" className="grid h-7 w-7 flex-none place-items-center rounded-[9px] bg-mist text-muted-2"><FaChalkboardTeacher size={16} strokeWidth={1.8} /></span>}
        <select
          id="homeroom-sel"
          aria-label="Homeroom"
          value={currentTeacherId == null ? '' : String(currentTeacherId)}
          onChange={(e) => setMut.mutate(e.target.value === '' ? null : Number(e.target.value))}
          className="min-h-[40px] min-w-0 flex-1 bg-transparent text-sm font-semibold text-ink"
        >
          <option value="">{current ? '— None —' : '[Pick homeroom teacher]'}</option>
          {teachers.map((t) => (
            <option key={t.profile_id} value={t.profile_id}>
              {t.first_name} {t.last_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
